import logo from "../../assets/logo.png";
import { Fragment, useContext, useState } from "react";
import { AuthContext } from "../../context";
import styles from "./styles.module.css";
import { userLinks } from "./links";
import { FaSignOutAlt } from "react-icons/fa";
import { RiAppsFill } from "react-icons/ri";
import { SlClose } from "react-icons/sl";
import { Link, useNavigate } from "react-router-dom";
import { IconType } from "react-icons";

type NavItem = {
  route: string;
  name: string;
  Icon: IconType;
  allowed: string[];
  children?: NavItem[];
};

type NavProps = {
  pageTitle: string;
};

const Navigation = ({ pageTitle }: NavProps) => {
  const { user, logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const role: any = "User";

  const navLinks: NavItem[] = userLinks;

  const hasPermission = (roles: string, allowedRoles: string[]) => {
    return allowedRoles.includes(roles);
  };

  const logoutHandler = () => {
    logout();
    navigate("/");
  };

  return (
    <>
      <div
        className={`${styles.toggle} ${open && styles.openToggle}`}
        onClick={() => setOpen(!open)}
      >
        {open ? <SlClose /> : <RiAppsFill />}
      </div>

      <div
        className={`${styles.navigation} ${styles.navLG} ${
          open && styles.openNav
        }`}
      >
        <div className={styles.logo}>
          <img src={logo} alt="Logo" />
          Enricher
        </div>

        <div className={styles.links}>
          <ul>
            {navLinks.map(
              (item, i) =>
                hasPermission(role, item?.allowed) && (
                  <Fragment key={i}>
                    {item?.children ? (
                      <div className={styles.childContainer}>
                        <li
                        // onClick={() => toggleHandler(i)}
                        >
                          <span>{item.name}</span>
                        </li>

                        {/* {newItems[i] && ( */}
                        <div className={styles.child}>
                          <ul>
                            {item?.children?.map((child, x) => (
                              <li
                                key={x}
                                className={
                                  pageTitle === child?.name
                                    ? styles.childActive
                                    : undefined
                                }
                              >
                                <Link to={child.route}>
                                  <child.Icon size={16} />
                                  {child.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                        {/* )} */}
                      </div>
                    ) : (
                      hasPermission(role, item?.allowed) && (
                        <li
                          key={i}
                          className={
                            pageTitle === item?.name ? styles.active : undefined
                          }
                        >
                          <Link to={item.route}>
                            <item.Icon size={16} />
                            {item.name}
                          </Link>
                        </li>
                      )
                    )}
                  </Fragment>
                )
            )}

            <li className={styles.logout}>
              <Link to="#" onClick={logoutHandler}>
                <FaSignOutAlt size={16} /> Logout
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Navigation;
